import React from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import { LAYOUT_BOX } from 'config/constants/ui'
import { useGlobalState } from 'src/sites/state'

const MultiPageNavPane = ({ children }) => {
   const { theme } = useGlobalState()
   const isFixedWidthLayout = theme.layoutContentFillMode === 'fixed'
   const isBoxGL = theme.tmpGlobalLayout === LAYOUT_BOX
   const menuWidth = isBoxGL
      ? '100%[a-b] 32vw[c] 330px[d] 370px[e] 370px[f]'
      : '100%[a-b] 32vw[c] 300px[d] 350px[e-f]'

   return (
      <View
         float="left"
         height="100%"
         width="100%[a-b]"
         paddingLeft={isFixedWidthLayout
            ? theme.tmpViewportPadding
            : `
               ${theme.tmpViewportPaddingA}[a]
               ${theme.tmpViewportPaddingB}[b]
               ${theme.tmpViewportPaddingC}[c]
               `
         }
         scroll="on">
         <View
            position="relative"
            float="left"
            width={menuWidth}
            height="100%"
            backgroundColor={theme.tmpContentBackgroundColor}
            borderRight={`1px solid ${theme.tmpColumnBorderColor}[c-f]`}>
            {children}
         </View>
      </View>
   )
}

MultiPageNavPane.propTypes = {
   children: PropTypes.node.isRequired
}

export default MultiPageNavPane
